import { IMyPosMiniPlugin } from '@pos-common/classes';

import { MyPosMiniPlugin } from '@pos-common/classes';
// import { MyPosMiniPluginMock as MyPosMiniPlugin } from '@paymash/capacitor-mypos-mini-types'; // mock

const plugin = MyPosMiniPlugin as IMyPosMiniPlugin;

export { plugin as MyPosMiniPlugin };
